import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Modal Components
import { UserOnWithoutLicenseModalComponent } from './user-on-without-license-modal/user-on-without-license-modal.component';
import { UserOnProLicenseModalComponent } from './user-on-pro-license-modal/user-on-pro-license-modal.component';
import { UserOnProLicensePostProjectModalComponent } from './user-on-pro-license-post-project-modal/user-on-pro-license-post-project-modal.component';
import { UserOnProLicensePostLibraryModalComponent } from './user-on-pro-license-post-library-modal/user-on-pro-license-post-library-modal.component';
import { CstbLicenseModalComponent } from './cstb-license-modal/cstb-license-modal.component';

@NgModule({
  imports: [
    CommonModule,
    UserOnWithoutLicenseModalComponent,
    UserOnProLicenseModalComponent,
    UserOnProLicensePostProjectModalComponent,
    UserOnProLicensePostLibraryModalComponent,
    CstbLicenseModalComponent
  ],
  exports: [
    UserOnWithoutLicenseModalComponent,
    UserOnProLicenseModalComponent,
    UserOnProLicensePostProjectModalComponent,
    UserOnProLicensePostLibraryModalComponent,
    CstbLicenseModalComponent
  ]
})
export class ModalsModule { } 